import { useEffect } from 'react'

import { useEInvoicingSetup } from '@features/eInvoicing/hooks/useEInvoicingSetup'

import { useSegment } from '../../../../../hooks'

interface EInvoicingTabViewTrackerProps {
  isEInvoicing: boolean
}

export const EInvoicingTabViewTracker = ({ isEInvoicing }: EInvoicingTabViewTrackerProps): null => {
  const { track } = useSegment()
  const { kycStatus } = useEInvoicingSetup()

  useEffect(() => {
    if (isEInvoicing && kycStatus === 'KYC_APPROVED') {
      track('xxx - e-invoicing - Viewed "E-invoices Tab in Receipts Section"')
    }
  }, [isEInvoicing, kycStatus, track])

  return null
}
